import api from "api/flexapi";

export const FETCH_NEWSLETTERS_START = "FETCH_NEWSLETTERS_START";
export const FETCH_NEWSLETTERS_SUCCESS = "FETCH_NEWSLETTERS_SUCCESS";
export const FETCH_NEWSLETTERS_ERROR = "FETCH_NEWSLETTERS_ERROR";

export const FETCH_NEWSLETTER_DETAIL_START = "FETCH_NEWSLETTER_DETAIL_START";
export const FETCH_NEWSLETTER_DETAIL_SUCCESS = "FETCH_NEWSLETTER_DETAIL_SUCCESS";
export const FETCH_NEWSLETTER_DETAIL_ERROR = "FETCH_NEWSLETTER_DETAIL_ERROR";

export const NEWSLETTER_CALENDER_YEAR_CHANGED = "NEWSLETTER_CALENDER_YEAR_CHANGED";

export const fetchNewsletters = (planId, params) => dispatch => {
  dispatch({ type: FETCH_NEWSLETTERS_START });

  api
    .getNewsletters(planId, params)
    .then(res => {
      dispatch({
        type: FETCH_NEWSLETTERS_SUCCESS,
        payload: { ...res.body },
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_NEWSLETTERS_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};
export const fetchNewsletterDetail = id => dispatch => {
  dispatch({ type: FETCH_NEWSLETTER_DETAIL_START });

  api
    .getNewsletterDetail(id)
    .then(res => {
      dispatch({
        type: FETCH_NEWSLETTER_DETAIL_SUCCESS,
        payload: res.body,
      });
    })
    .catch(err => {
      dispatch({
        type: FETCH_NEWSLETTER_DETAIL_ERROR,
        payload: err.response ? err.response.body : err,
      });
    });
};

export const newsletterCalenderYearChanged = () => dispatch => {
  dispatch({ type: NEWSLETTER_CALENDER_YEAR_CHANGED });
};



// WEBPACK FOOTER //
// ./actions/newsletterActions.js